import { ActionReducerMap } from '@ngrx/store';
import { filterUsersReducers } from '../../../core/store/reducers/filter-users.reducers';
import { currentUserGroupsReducers } from './current-user-groups.reducers';
import { userGroupsListReducers } from './user-groups-list.reducers';
import { pendingChangesReducer } from 'app/core/store/reducers/pending-changes.reducers';


export const MANAGE_GROUPS_REDUCER: ActionReducerMap<IUserGroupState> = {
    currentUserGroup: currentUserGroupsReducers,
    userGroupList: userGroupsListReducers,
    filterUsers: filterUsersReducers,
    pendingChanges: pendingChangesReducer
};